export default __webpack_public_path__ + "static/media/ip-link-circle.6b6b88b1.svg";